import Vue from 'vue';
import EdVideoViewer from '@/content/pages/course-viewer/components/ed-video-viewer/ed-video-viewer.vue';
import EdLinkViewer from '@/content/pages/course-viewer/components/ed-link-viewer/ed-link-viewer.vue';
import EdTextViewer from '@/content/pages/course-viewer/components/ed-text-viewer/ed-text-viewer.vue';
import EdFileViewer from '@/content/components/ed-file-viewer/ed-file-viewer.vue';
import EdImagesViewer from '@/content/pages/course-viewer/components/ed-images-viewer/ed-images-viewer.vue';
import EdSubdeckViewer from '@/courses/components/flash-cards/ed-subdeck-viewer/ed-subdeck-viewer.component.vue';
import { COURSES_EVENTS } from '@/courses/values/courses-events.values';
import { SECTION_TYPES } from '../../../content/values/sections';
import { HOMEWORKS_EVENTS, _HOMEWORKS_STORE } from '@/homework/values/homeworks.values';
import { IParamsModalConfirmation } from '@/plugins/ed-modal/interfaces/params-modal-confirmation.interface';
import { SCREEN_MIRRORING_EVENTS } from '@/values/screen.mirroring.values';
import { ScreenMirroringService } from '@/services/screen.mirroring.service';
import { UserPositionObserverMixin } from '@/core/mixins/user-position-observer.mixin';
import { BackupFileServices } from '@/core/services/backup.file.services';
import { BOARD_EVENTS } from '@/values/ed-whiteboard.values';

export default Vue.component('ed-homework-viewer', {
  name: 'ed-homework-viewer',
  props: ['params'],
  mixins: [UserPositionObserverMixin],
  components: {
    EdVideoViewer,
    EdLinkViewer,
    EdTextViewer,
    EdFileViewer,
    EdImagesViewer,
    EdSubdeckViewer
  },
  data: () => {
    return {
      classes: null,
      viewerId: 0,
    }
  },
  computed: {
    canResponse() {
      return this.params.canResponse;
    }
  },
  methods: {
    setViewer() {
      this.classes = this.params.viewer == SECTION_TYPES.LESSON_VIDEO.viewer ? 'noPadding': '';
    },
    onClickBugButton() {
      BackupFileServices.sendUserInfoFromBugButton();
    },
    notifyUserPosition(homeworkViewerIsOpen = true) {
      const sectionId = this.params.section.sectionId;
      const classId = this.params.section.classId || this.params.course.classId;
      const courseId = this.params.section.courseId || this.params.course?.id;
      const homeworkId = (this.params.responseDraft || this.params.response)?.id || this.params.section.id;
      const userPositionParams = homeworkViewerIsOpen ? {classId, courseId, sectionId, homeworkId} : {classId, courseId};
      
      this.$App.Store.updateUserPosition(userPositionParams);
    },
    closeModal(emitMirroringEvent : boolean = true) {
      
      //In order to prevent data loss, book mode by itself is not able to close any homework, It requires paper mode closing homework event
      if(ScreenMirroringService.isBookModeActive(this)) {
        if(emitMirroringEvent) {
          if(!this.params.isFeedback) {
            if (this.params.canResponse) {
              this.$edEventBus.$emit(
                SCREEN_MIRRORING_EVENTS.CLICK,
                this,
                { target: SCREEN_MIRRORING_EVENTS.ON_CLOSE_HOMEWORK_VIEWER }
              );
            } else {
              this.$edEventBus.$emit(SCREEN_MIRRORING_EVENTS.ON_CLOSE_HOMEWORK_VIEWER);
            }
          } else {
            this.$edEventBus.$emit(HOMEWORKS_EVENTS.HOMEWORK_VIEWER_IS_CLOSED);
            this.$EdModal.closeModal();
          }
        } else {
          this.$store.commit(_HOMEWORKS_STORE.MUTATIONS.CHANGE_CONFIRM_CLOSE_HOMEWORK_VIEWER, false);
          this.$edEventBus.$emit(HOMEWORKS_EVENTS.HOMEWORK_VIEWER_IS_CLOSED);
          this.$EdModal.closeModal();
        }
        return;
      }
      
      if(this.$store.state.HomeworksStore.confirmCloseHomeworkViewer) {
        this.$EdModal.createConfirmationModal(this.getHomeworkConfirmationModalParams());
      } else {
        this.$store.commit(_HOMEWORKS_STORE.MUTATIONS.CHANGE_CONFIRM_CLOSE_HOMEWORK_VIEWER, false);
        this.$edEventBus.$emit(HOMEWORKS_EVENTS.HOMEWORK_VIEWER_IS_CLOSED);
        this.$EdModal.closeModal();
        this.$edEventBus.$emit(SCREEN_MIRRORING_EVENTS.CLICK, this, {target:SCREEN_MIRRORING_EVENTS.ON_CLOSE_HOMEWORK_VIEWER});
      }

    },
    closeModalWithoutMirroring() {
      this.closeModal(false);
    },
    getHomeworkConfirmationModalParams(): IParamsModalConfirmation {
      return {
        body: this.$i18n.t('common.confirmExit'),
        actionText: this.$i18n.t('courses.writeObject.saveAndExit'),
        action: () => {
          this.$edEventBus.$emit(COURSES_EVENTS.SAVE_AND_CLOSE_HOMEWORK);
          this.$edEventBus.$emit(SCREEN_MIRRORING_EVENTS.CLICK, this, {target:SCREEN_MIRRORING_EVENTS.ON_CLOSE_HOMEWORK_VIEWER});
        },
        secondActionText: this.$i18n.t('common.exit'),
        secondAction: () => {
          this.$store.commit(_HOMEWORKS_STORE.MUTATIONS.CHANGE_CONFIRM_CLOSE_HOMEWORK_VIEWER, false);
          this.$edEventBus.$emit(HOMEWORKS_EVENTS.HOMEWORK_VIEWER_IS_CLOSED);
          this.$EdModal.closeModal();
          this.$edEventBus.$emit(SCREEN_MIRRORING_EVENTS.CLICK, this, {target:SCREEN_MIRRORING_EVENTS.ON_CLOSE_HOMEWORK_VIEWER});
        },
        thirdActionText:  this.$i18n.t('common.cancel'),
        thirdAction: () => {}
      } 
    },
    checkFileInfo() {
      let dataFile: any = { sectionId: this.params.section.sectionId , classId: this.params.classId,
      courseId: this.params.courseId , course: this.params.course };
      this.$edEventBus.$emit(COURSES_EVENTS.CHECK_IF_FILE_READY, dataFile);
    },
    reloadHomework(){
      this.viewerId++;
    },
  },
  created() {
    this.$store.commit(_HOMEWORKS_STORE.MUTATIONS.CHANGE_CONFIRM_CLOSE_HOMEWORK_VIEWER, false);
    this.$edEventBus.$on(SCREEN_MIRRORING_EVENTS.ON_CLOSE_HOMEWORK_VIEWER, this.closeModalWithoutMirroring );
  },
  mounted() {
    this.$edEventBus.$on(COURSES_EVENTS.CLOSE_HOMEWORK_VIEWER, this.closeModal);
    this.$edEventBus.$on(BOARD_EVENTS.REFRESH_BOARD, this.reloadHomework);
    this.setViewer();
    this.notifyUserPosition();
  },
  beforeDestroy() {
    this.$edEventBus.$off(SCREEN_MIRRORING_EVENTS.ON_CLOSE_HOMEWORK_VIEWER, this.closeModalWithoutMirroring);
    this.$edEventBus.$off(COURSES_EVENTS.CLOSE_HOMEWORK_VIEWER, this.closeModal);
    this.$edEventBus.$off(BOARD_EVENTS.REFRESH_BOARD);
    this.notifyUserPosition(false);
  }
});